import { Text, VStack } from 'ui_2';
import { BiChevronLeft, BiX } from 'react-icons/bi';
import { useBreakpoints } from '@puzzlehq/frontend-utils';
import { ReactNode, useMemo } from 'react';
import { FileRouteTypes, Link } from '@tanstack/react-router';
import { useViewTransition } from '@src/hooks/useViewTransition';
import { router } from '@src/providers/router';

type HeaderProps = {
  title?: string | ReactNode;
  close?: boolean;
  backRoute: FileRouteTypes['to'];
  viewTransition?: boolean;
  onClick?: () => void;
};

const Header = ({
  onClick,
  title,
  backRoute,
  close = false,
  viewTransition = false,
}: HeaderProps) => {
  const { isMedium } = useBreakpoints();
  const { slideRightFullPage } = useViewTransition();
  const canGoBack = useMemo(() => router.history.canGoBack(), []);

  return (
    <VStack className='w-full gap-2 px-4'>
      <div className='flex w-full items-center'>
        {/* left */}
        <div className='flex justify-start'>
          {!close && (canGoBack || backRoute) && (
            <Link
              to={backRoute}
              onClick={onClick}
              viewTransition={viewTransition ? slideRightFullPage : undefined}
            >
              <BiChevronLeft
                size={isMedium ? 40 : 24}
                className={'text-black md:-ml-3'}
              />
            </Link>
          )}
          {close && (
            <Link to={backRoute} onClick={onClick}>
              <BiX
                size={isMedium ? 40 : 24}
                className={'text-black md:-ml-3'}
              />
            </Link>
          )}
        </div>
        {/* center on mobile, left on desktop */}
        <div className='flex-1 text-center md:ml-4 md:text-left'>
          {typeof title === 'string' ? (
            <Text font={isMedium ? 'bold-lg' : 'bold-md'}>{title}</Text>
          ) : (
            title
          )}
        </div>
        {/* right - Empty space */}
        <div className='w-6 md:hidden' />
      </div>
    </VStack>
  );
};
export default Header;
